import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ProjectFilter } from '../components/ProjectFilter';
import { ProjectModal } from '../components/ProjectModal';
import { SEO } from '../components/SEO';
import { ArrowUpRight } from 'lucide-react';
const categories = ['All', 'Branding', 'Digital', 'Content', 'Motion', 'Photography'];
const projects = [{
  id: 1,
  title: 'Bikebosque',
  category: 'Branding',
  year: '2024',
  image: 'https://cdn.magicpatterns.com/uploads/5kiDeygQUjbnM9BAdWXAXo/WEB_01.png',
  height: 'h-[500px]',
  detailImages: ['https://cdn.magicpatterns.com/uploads/5kiDeygQUjbnM9BAdWXAXo/WEB_01.png', 'https://cdn.magicpatterns.com/uploads/jjXMA2ss2qwdqwJQ3QuTSM/WEB_02.png', 'https://cdn.magicpatterns.com/uploads/mXYDUGEG6Fb3oGjzpXLzcD/WEB_03.png', 'https://cdn.magicpatterns.com/uploads/iwcrenaPTn1JLV9KkhmTZW/WEB_04.png', 'https://cdn.magicpatterns.com/uploads/tQzuevRzZJ74tKrjQoWwah/WEB_05.png', 'https://cdn.magicpatterns.com/uploads/hAJa2KuLVQrZn1YV7kPavn/WEB_06.png', 'https://cdn.magicpatterns.com/uploads/pV9BEHmY5MZtvKfQMwHLjZ/WEB_07.png']
}, {
  id: 2,
  title: 'Ayam Bakar Pancasan',
  category: 'Branding',
  year: '2022',
  image: 'https://cdn.magicpatterns.com/uploads/buSgHHX1ewNGubdDr7KyhT/Ayam_Bakar_Pancasan_00.png',
  height: 'h-[400px]',
  detailImages: ['https://cdn.magicpatterns.com/uploads/buSgHHX1ewNGubdDr7KyhT/Ayam_Bakar_Pancasan_00.png', 'https://cdn.magicpatterns.com/uploads/fReBVf3tw9NHysF5nAZZ1W/Ayam_Bakar_Pancasan_01.png', 'https://cdn.magicpatterns.com/uploads/7bCSWFQbs1NYiw767dVLd8/Ayam_Bakar_Pancasan_02.png', 'https://cdn.magicpatterns.com/uploads/tC9NfQ45PWPBiqywA9NGxq/Ayam_Bakar_Pancasan_03.png', 'https://cdn.magicpatterns.com/uploads/4pgLA9MpywiKKBYjZH7uCJ/Ayam_Bakar_Pancasan_04.png', 'https://cdn.magicpatterns.com/uploads/cHJi9N5jefyU5CCNNN6zBN/Ayam_Bakar_Pancasan_05.png', 'https://cdn.magicpatterns.com/uploads/joZkpK5YY9svsRB2vPGeZb/Ayam_Bakar_Pancasan_06.png']
}, {
  id: 3,
  title: 'Jersey Army ID',
  category: 'Branding',
  year: '2023',
  image: 'https://cdn.magicpatterns.com/uploads/hmLX5mQzW5QBEiX3gBKo45/JAI-logo_00.png',
  height: 'h-[380px]',
  detailImages: ['https://cdn.magicpatterns.com/uploads/hmLX5mQzW5QBEiX3gBKo45/JAI-logo_00.png', 'https://cdn.magicpatterns.com/uploads/8HWUPFLTPq3CTpsFZjvgYq/JAI-logo_01.png', 'https://cdn.magicpatterns.com/uploads/krGx5yka6hWHrgbxdxFK1p/JAI-logo_02.png', 'https://cdn.magicpatterns.com/uploads/95BghFCTXF4CEkuSw4qViz/JAI-logo_03.png']
}, {
  id: 4,
  title: 'Punya Saka',
  category: 'Branding',
  year: '2020',
  image: 'https://cdn.magicpatterns.com/uploads/aQNs4QRuhozkYfqKxbCpvf/Punya_Saka_-_Logo_00.png',
  height: 'h-[360px]',
  detailImages: ['https://cdn.magicpatterns.com/uploads/aQNs4QRuhozkYfqKxbCpvf/Punya_Saka_-_Logo_00.png', 'https://cdn.magicpatterns.com/uploads/7gDdy3n949XpmXXmDxTzuz/Punya_Saka_-_Logo_01.png', 'https://cdn.magicpatterns.com/uploads/mWyn1oHv7ezyhJzdxyEqvR/Punya_Saka_-_Logo_02.png', 'https://cdn.magicpatterns.com/uploads/3bj9tfvRRuZgB4fpFdvWh9/Punya_Saka_-_Logo_03.png', 'https://cdn.magicpatterns.com/uploads/edaLLuQGocgF79oegAHWkY/Punya_Saka_-_Logo_04.png']
}, {
  id: 5,
  title: 'Tea Di Tu',
  category: 'Branding',
  year: '2021',
  image: 'https://cdn.magicpatterns.com/uploads/m8AYnCdA6pFFjPEic4Cq81/TeaDitu-Logo-v3-rev02_00.png',
  height: 'h-[420px]',
  detailImages: ['https://cdn.magicpatterns.com/uploads/m8AYnCdA6pFFjPEic4Cq81/TeaDitu-Logo-v3-rev02_00.png', 'https://cdn.magicpatterns.com/uploads/uFdtPCMdZvB1J23tC6koh3/TeaDitu-Logo-v3-rev02_01.png', 'https://cdn.magicpatterns.com/uploads/drjewWA992KESybtBPmmtc/TeaDitu-Logo-v3-rev02_02.png', 'https://cdn.magicpatterns.com/uploads/e9Cgbhp7eku9ycZNzrDgLj/TeaDitu-Logo-v3-rev02_03.png']
}];
export function Work() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [selectedProject, setSelectedProject] = useState<(typeof projects)[0] | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const filteredProjects = activeCategory === 'All' ? projects : projects.filter(project => project.category === activeCategory);
  const handleProjectClick = (project: (typeof projects)[0]) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };
  return <div className="min-h-screen bg-black text-white selection:bg-yellow-400 selection:text-black" data-id="element-279">
      <SEO title="Portfolio Desain | KUJODO Studio Cimahi, Bandung" description="Lihat portofolio desain branding, logo, dan packaging dari KUJODO Studio. Creative studio di Cimahi dan Bandung dengan pengalaman menangani berbagai brand lokal Indonesia." keywords="portfolio desain Bandung, portfolio branding Cimahi, desain logo Bandung, branding agency Cimahi, KUJODO portfolio" canonical="https://kujodo.id/work" data-id="element-280" />
      <Navigation data-id="element-281" />

      <main className="pt-32 pb-24 px-6" data-id="element-282">
        <div className="max-w-7xl mx-auto" data-id="element-283">
          {/* Header */}
          <div className="mb-16" data-id="element-284">
            <h1 className="text-6xl md:text-8xl font-black tracking-tighter mb-8" data-id="element-285">
              OUR <span className="text-yellow-400" data-id="element-286">WORK</span>
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl leading-relaxed" data-id="element-287">
              A curated selection of our favorite projects. We help brands stand
              out through bold design and immersive digital experiences.
            </p>
          </div>

          {/* Filter */}
          <ProjectFilter categories={categories} activeCategory={activeCategory} onSelectCategory={setActiveCategory} data-id="element-288" />

          {/* Grid */}
          <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8" data-id="element-289">
            {filteredProjects.map(project => <div key={project.id} onClick={() => handleProjectClick(project)} className="group relative break-inside-avoid overflow-hidden cursor-pointer bg-gray-900" data-id="element-290">
                <div className={`w-full ${project.height} relative`} data-id="element-291">
                  <img src={project.image} alt={project.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" data-id="element-292" />

                  {/* Overlay */}
                  <div className="absolute inset-0 bg-yellow-400/95 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-between p-8" data-id="element-293">
                    <div className="flex justify-between items-start translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-75" data-id="element-294">
                      <span className="text-black font-bold tracking-widest uppercase text-sm border border-black px-2 py-1" data-id="element-295">
                        {project.category}
                      </span>
                      <span className="text-black font-bold text-sm" data-id="element-296">
                        {project.year}
                      </span>
                    </div>

                    <div className="translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-100" data-id="element-297">
                      <h3 className="text-black text-4xl font-black uppercase tracking-tighter mb-4" data-id="element-298">
                        {project.title}
                      </h3>
                      <div className="flex items-center text-black font-bold uppercase tracking-wider text-sm group/link" data-id="element-299">
                        View Project
                        <ArrowUpRight className="ml-2 w-5 h-5 transition-transform group-hover/link:translate-x-1 group-hover/link:-translate-y-1" data-id="element-300" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </main>

      <ProjectModal project={selectedProject} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-301" />

      <Footer data-id="element-302" />
    </div>;
}